/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="9.32"
        height="12.03"
        viewBox="0 0 9.32 12.03"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="m4.68 2.34 4.63 4.65-.71.71-3.41-3.45v7.78h-1V4.27L.72 7.72l-.7-.71ZM9.1 0v1H.19V0Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'ArrowUpToLineIcon';

export default Icon;
